// extracted by mini-css-extract-plugin
module.exports = {"skeletonWrapper":"pGEq1pT0"};